// 自作のJS/css/imageの読み込み
import Kitty from '@/src/js/application'
import '@/src/stylesheets/application.scss'
import.meta.globEager('@/src/images/**/*')

// 自作JSの実行
Kitty.start()
